import { useAgentName } from '../../../lib/use-agent-name';
import { useTranslation } from '../../../lib/i18n';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { useOpenSideChat } from '../../../lib/use-open-side-chat';
import { AgentsEmptyHero, EmptyIntro } from '../EmptyIntro';
import { YOUR_AGENTS_PAGE } from './use-your-agents';

/**
 * Your Agents with no team yet (Figma `10941:75358`): the orbit illustration over
 * "A team that grows with your business", the three steps, and the CTA that asks the
 * Maestro to start building. Replaces the genome + pile entirely — there is nothing to
 * plot until the team exists. Native parity: `AgentsEmptyIntro` in
 * `android/.../features/Pages.kt` / `emptyTeamPanel` on iOS, same copy keys.
 */
export function AgentsEmptyIntro() {
  const { t } = useTranslation();
  const agent = useAgentName();
  const { logPageClickBi } = useGenericBi();
  const openSideChat = useOpenSideChat();

  return (
    <EmptyIntro
      illustration={<AgentsEmptyHero />}
      title={t('agents.empty.title')}
      steps={[
        t('agents.empty.step1', { agentName: agent.short }),
        t('agents.empty.step2'),
        t('agents.empty.step3'),
      ]}
      ctaLabel={t('agents.empty.cta')}
      onCta={() => {
        logPageClickBi({ page_name: YOUR_AGENTS_PAGE, button_name: 'start_building_team' });
        openSideChat({ kind: 'new', message: t('agents.empty.seed') });
      }}
    />
  );
}
